import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconArrowPathUp"><Path d="M4.17939 9.76329C3.98952 9.98589 3.94643 10.2986 4.06901 10.5642C4.19158 10.8299 4.45744 11 4.75001 11H8.00001V21.25C8.00001 21.6642 8.3358 22 8.75001 22H15.25C15.6642 22 16 21.6642 16 21.25V11H19.25C19.5426 11 19.8084 10.8299 19.931 10.5642C20.0536 10.2986 20.0105 9.98589 19.8206 9.76329L12.5706 1.26329C12.4281 1.09623 12.2196 1 12 1C11.7804 1 11.5719 1.09623 11.4294 1.26329L4.17939 9.76329Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathUp;
